import { Injectable } from '@angular/core';
import { SignatureState } from '../models/signatureState.model';
import { SafeResourceUrl } from '@angular/platform-browser';

@Injectable()

export class SignatureService {

    // Bon de commande
    public errorState?: SignatureState = null;
    private urlSignature: SafeResourceUrl = null;

    // Mandat Sepa
    private urlSignatureSepa: SafeResourceUrl = null;

    constructor() { }

    public setUrlSignature(url: SafeResourceUrl) {
        this.urlSignature = url;
    }

    public getUrlSignature(): SafeResourceUrl {
        return this.urlSignature;
    }

    public getUrlSignatureSepa(): SafeResourceUrl {
        return this.urlSignatureSepa;
    }

    public setUrlSignatureSepa(url: SafeResourceUrl) {
        this.urlSignatureSepa = url;
    }

}
